export enum userGroup {
  ADMIN = 'admin',
  REVIEWER = 'reviewer',
  USER_WO_EVENTS = 'user_wo_events',
  EVENT_REVIEWER = 'event_reviewer',
  EXTERNAL_REVIEWER = 'external_reviewer',
  MANUFACTURER = 'manufacturer',
  PORTAL_READER = 'portal_reader',
  FLEET_ADMIN = 'fleet_admin',
  CUSTOMER_ADMIN = 'customer_admin',
  CITATION_RESOLUTION_REPRESENTATIVE = 'citation_resolution_representative',
}
